<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  (valueChangeByApiName)="onChange($event)"
  reportName="PayCcompaniest"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="_columns && _columns.length > 0">
    <ssg-button
      [disabled]="model?.ElementPropertys?.length <= 0"
      (click)="editFormula()"
      tooltip="فرمول عامل"
      icon="icon-library_add-f"
      size="small"
      class="btnheader">
    </ssg-button>
    <div class="list-wrapper">
      <kgrid
        id="ElementPropertys"
        #ElementPropertys
        [areaName]="areaName"
        label="خصوصیت عوامل"
        name="ElementPropertys"
        [columns]="_columns"
        [groupable]="false"
        [noToolBar]="true"
        (onRowSelected)="RowForSelect = $event"
        [dataList]="model.ElementPropertys"
        (onDelete)="onDeleteElementProperty($event)"
        (onCreate)="onCreateElementProperty($event)"
        (onEdit)="onEditElementProperty($event)"
        [paging]="false">
      </kgrid>
    </div>
  </ng-container>
</dynamic-form>
